<script>
import {
  ScCard,
  ScSpinner,
  ScTooltip,
} from '@intelipost-js/secure-components';
import formatPTCurrency from '../../shared/CurrencyFormatter';

export default {
  name: 'billings-totalizers',
  methods: { formatPTCurrency },
  props: {
    totalizers: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      totalizersLabels: {
        billingsCount: 'Faturas',
        billingsTotalValue: 'Valor total das faturas',
        shipmentOrdersCount: 'Total de pedidos',
        divergentBillingsCount: 'Faturas com divergência',
        divergentBillingsTotalValue: 'Valor total da divergência',
      },
    };
  },
  components: {
    ScCard,
    ScSpinner,
    ScTooltip,
  },
};
</script>

<template>
  <div class="page-content__totalizers">
    <sc-card v-for="(t, i) in totalizers" :key="i">
      <template slot="body">
          <sc-tooltip v-if="t.label" type="is-dark" position="is-bottom" :label="t.label" class="custom-title__tooltip" multilined append-to-body>
            <p class="totalizers-title"> {{ totalizersLabels[t.field] }} </p>
          </sc-tooltip>
          <p v-else class="totalizers-title"> {{ totalizersLabels[t.field] }} </p>
        <p class="page-content__totalizers__values">
        <span v-if="t.loading"><sc-spinner /></span>
        <span v-else>
          <span v-if="t.isCurrency">{{ t.value ? formatPTCurrency(t.value) : 'R$ 0,00' }}</span>
          <span v-else>{{ t.value || 0 }}</span>
        </span>
        </p>
      </template>
    </sc-card>
  </div>
</template>

<style scoped lang="scss">
@import "~@intelipost-js/secure-ui/src/scss/variables"; //eslint-disable-line
.page-content {
  &__totalizers {
    margin-top: 1em;
    display: flex;
    justify-content: space-between;
    margin-left: -0.75em;
    margin-right: -0.75em;

    .sc-card {
      flex: 1;
      margin: 0.75em;
      border-radius: 8px;

      &__custom-title {
        color: $primary;
        font-size: 1em;
        font-weight: normal;
        display: flex;
        align-items: center;
        padding: 0.75em;
      }
    }

    &__values {
      font-size: 20px;
      font-weight: bold;
      color: $primary;
    }
    .totalizers-title {
      margin-bottom: 8px;
      font-weight: 400;
      color: #002716;
      line-height: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/billing/components/billings-totalizers/BillingsTotalizers.vue?1628616c